import { CaretRightOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import {
  APP_LANGUAGE,
  KEY_PRODUCT_KIND,
  // DEFAULT_LIMIT,
  // DEFAULT_OFFSET,
  ROUTER_PATH,
  // UTILITY_DATA,
  WIDTH_IPAD,
  // WIDTH_IPAD,
} from "../../common/constant";
import FilterProduct from "../../components/filterProduct";
import { filterOptions, products, sections } from "../../services";
import { setTitlePage } from "../../utils/helper";
import FilterItemModal from "./filterItemModal";
import "./style.scss";
import _ from "lodash";
import queryString from "query-string";
import {
  checkQuerySyntax,
  getSectionCategoryDescriptionBySlug,
  getSlugByLanguage,
  localizeRouteKey,
  prepareProductVirtualizeItem,
  slugify,
} from "../../shared/helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  getBannersCategory,
  selectBannersCategory,
} from "../../redux/reducers/slice/category";
import BannersCategory from "../../components/bannersCategory";
import { selectIsLoading } from "../../redux/reducers/slice/home";
import ProductCategoryHeader from "./productCategoryHeader";
import { IFilterOptionProps } from "../../models/interface";
import VirtualizeItem from "../../components/virtualizeItem";

const service = products;

const ICON_SEARCH =
  "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/Search-icon-85.svg";
const ICON_SEARCH_2 =
  "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/Search-icon-86.svg";

const ProductsCategory = (props: any) => {
  const { history, location, match } = props;
  const { t, i18n } = useTranslation();
  const isLoading = useSelector(selectIsLoading);
  const [sectionCategory, setSectionCategory] = useState<any>([]);
  const [dataProducts, setDataProducts] = useState<any>([]);
  const [productOptions, setProductOptions] = useState<any>([]);
  const [filters, setFilters] = useState<any>({});
  const [filterOptionList, setFilterOptionList] = useState<any>([]);
  const [currentFilter, setCurrentFilter] = useState<any>([]);
  const [isShowFilters, setIsShowFilters] = useState(false);
  const [isShowOptions, setIsShowOptions] = useState(false);
  const { innerWidth } = window;
  const refModal = useRef<any>(null);

  const slug =
    i18n.language === APP_LANGUAGE.Vietnamese
      ? match.params.slug
      : t(`slug_${match.params.slug}`);
  const urlEndpoint =
    location.pathname.split("/")[location.pathname.split("/").length - 1];
  const _query =
    (location.search &&
      queryString.parse(location.search)[t("detail_query")]) ||
    "";

  const dispatch = useDispatch();
  const bannersCategory: any = useSelector(selectBannersCategory);

  useEffect(() => {
    setIsShowOptions(false);
    setIsShowFilters(false);
    setFilters({});
    if (slug) {
      getFilterOptionList({
        filters: {
          path: slug,
        },
      });
      service.getCategoryOptions(
        {
          path: slug,
          header_id: "",
          filter: {},
        },
        (data: any, err: any) => {
          if (data && data.length) {
            setProductOptions(
              data.map((p: any) => ({
                ...p,
                value: {
                  [t("detail_query")]: getSlugByLanguage(p, i18n.language),
                  id: p.cat_id,
                },
              }))
            );
          }
        }
      );
    }
  }, [match.params.slug]);

  useEffect(() => {
    if (slug && !checkQuerySyntax(location.search)) {
      const sectionIds = getSectionCategoryDescriptionBySlug(slug);

      if (sectionIds.length) {
        sections.getSections({ ids: sectionIds }, (data: any, err: any) => {
          if (data && data.data && data.data.length) {
            setSectionCategory(data.data);
          } else {
            setSectionCategory([]);
          }
        });
      } else {
        setSectionCategory([]);
      }
    } else {
      setSectionCategory([]);
    }

    if (
      !bannersCategory ||
      !bannersCategory[
        `${slug}${_query ? `?${t("detail_query")}=${_query}` : ""}`
      ]
    ) {
      const _path = _query ? { path: _query } : {};

      dispatch(
        getBannersCategory({
          path: slug,
          filter: _path,
        })
      );
    }

    setDataProducts([]);

    if (`/${urlEndpoint}` === t(ROUTER_PATH.SEARCH)) {
      const _keyword: any = queryString.parse(location.search);
      service.getProductSearch(
        0,
        10,
        _keyword[t("keyword")] || "",
        (data: any, err: any) => {
          if (data.length) {
            setTitlePage(data[0].category_name);
            setDataProducts(data);
          }
        }
      );
    } else {
      service.getProductsByCategory(
        {
          path: slug,
          header_id: "",
          filter: location.search
            ? getFilterParams(queryString.parse(location.search))
            : {},
        },
        (data: any, err: any) => {
          if (data) {
            if (location.search) {
              setFilters(queryString.parse(location.search));
            } else {
              setFilters({});
            }
            if (data.length) {
              setTitlePage(data[0].category_name);
            }
            setDataProducts(data);
          }
        }
      );
    }
  }, [match.params.slug, location.search]);

  const getFilterParams = (query: any) => {
    let _params = { ...query };
    let _id;

    if (!query[t("detail_query")]) {
      return _params;
    }

    if (productOptions && productOptions.length) {
      const _prod = productOptions.filter(
        (p: any) => p.slug === query[t("detail_query")]
      );
      _id = _prod && _prod.length ? _prod[0].cat_id : "";
    }

    if (_id) {
      _params.id = _id;
    } else {
      _params.path = query[t("detail_query")];
    }

    delete _params[t("detail_query")];

    return _params;
  };

  const getFilterOptionList = (query: IFilterOptionProps = {}) => {
    filterOptions.getFilterOptions(query, (data: any, err: any) => {
      if (data && data.docs && data.docs.length) {
        setFilterOptionList(_.sortBy(data.docs, ["order"]));
      } else {
        setFilterOptionList([]);
      }
    });
  };

  const getDataFilter = (values: any) =>
    values.length ? values : productOptions;

  const handleClickFilter = (e: any) => {
    e.preventDefault();
    if (!isShowFilters) {
      document.getElementById("filter")?.scrollIntoView();
    }
    setIsShowFilters(!isShowFilters);
    setIsShowOptions(!isShowOptions);

    if (innerWidth > WIDTH_IPAD) {
      const firstFilter = filterOptionList.filter((c: any) => c.order === 1)[0];
      setCurrentFilter([
        { ...firstFilter, values: getDataFilter(firstFilter.default_values) },
      ]);
    } else {
      setCurrentFilter(
        filterOptionList.map((c: any) => ({
          ...c,
          values: getDataFilter(c.default_values),
        }))
      );
    }
  };

  const handleClickFilterItem = (e: any, item: any) => {
    e.preventDefault();
    if (refModal && item.code != KEY_PRODUCT_KIND) {
      refModal.current.getFilterOptionData(item._id, (data: any) => {
        setCurrentFilter([
          {
            ...item,
            values: getDataFilter(data || item.default_values),
          },
        ]);
      });
    } else {
      setCurrentFilter([
        {
          ...item,
          values: getDataFilter(item.default_values),
        },
      ]);
    }
    setIsShowOptions(true);
  };

  const handleFilter = (filter: any) => {
    history.push(
      `${localizeRouteKey(
        ROUTER_PATH.CATEGORY
      )}/${slug}?${queryString.stringify(filter)}`
    );
  };

  const handleCloseModal = () => {
    setCurrentFilter([]);
    setIsShowFilters(false);
    setIsShowOptions(false);
  };

  const handleClickNextOrPrev = (
    index: number,
    step: number,
    values: any = null
  ) => {
    const currFilter: any = filterOptionList.filter(
      (m: any) => m.order === index + step
    )[0];
    const _values = getDataFilter(values || currFilter.default_values);
    setCurrentFilter([{ ...currFilter, values: _values }]);
  };

  const handleQuickClearFilters = (e: any) => {
    e.preventDefault();
    history.push(`${localizeRouteKey(ROUTER_PATH.CATEGORY)}/${slug}`);
  };

  const showFilterItems = () =>
    _.sortBy(filterOptionList, ["order"]).map((f: any, i: number) => (
      <Col className="kd-filter-products product-filter-item" key={i}>
        <a
          className={`filter-item ${
            f.code === currentFilter[0]?.code ? "filter-item-active" : ""
          }`}
          onClick={(e: any) => handleClickFilterItem(e, f)}>
          <span
            className={`filter-title ${
              f.code === currentFilter[0]?.code ? "filter-title-active" : ""
            }`}>
            {f.name}
          </span>
          <span
            className={`filter-step ${
              f.code === currentFilter[0]?.code ? "current-filter" : ""
            }`}>
            0{f.order}
          </span>
        </a>
      </Col>
    ));

  const element: any =
    document.getElementsByClassName("sort-filter-wrapper")[0] || null;

  const bannerImages =
    bannersCategory &&
    bannersCategory[
      `${slug}${_query ? `?${t("detail_query")}=${_query}` : ""}`
    ] &&
    bannersCategory[`${slug}${_query ? `?${t("detail_query")}=${_query}` : ""}`]
      .images;

  const virtualizeItems = prepareProductVirtualizeItem(
    dataProducts,
    sectionCategory && sectionCategory[0],
    bannerImages
  );

  if (!dataProducts || !dataProducts.length) {
    return <div style={{ height: "calc(100vh + 500px)", width: "100%" }}></div>;
  }

  if (dataProducts && dataProducts.length && innerWidth <= WIDTH_IPAD) {
    return (
      <VirtualizeItem
        virtualizeItems={virtualizeItems}
        history={history}
        slug={slug}
      />
    );
  }

  return (
    <div className="sort-filter-wrapper">
      {isShowOptions ? (
        <div
          onClick={() => handleCloseModal()}
          style={{ height: element && element.offsetHeight + 500 }}
          className="mask-filter"
        />
      ) : null}
      {sectionCategory.length && !checkQuerySyntax(location.search) ? (
        <ProductCategoryHeader
          history={history}
          sectionItem={sectionCategory[0]}
        />
      ) : null}
      {`/${urlEndpoint}` != t(ROUTER_PATH.SEARCH) ? (
        <Row className="image-product-filter">
          {bannersCategory &&
          bannersCategory[
            `${slug}${_query ? `?${t("detail_query")}=${_query}` : ""}`
          ] &&
          bannersCategory[
            `${slug}${_query ? `?${t("detail_query")}=${_query}` : ""}`
          ].images.length ? (
            <BannersCategory
              banners={
                bannersCategory[
                  `${slug}${_query ? `?${t("detail_query")}=${_query}` : ""}`
                ].images
              }
            />
          ) : (
            <img
              src="https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1618467254-HinhChudeNemDeluxe1280x550px-04.jpg"
              alt=""
            />
          )}
        </Row>
      ) : null}
      {filterOptionList.length ? (
        <Row
          gutter={8}
          style={{
            position: "sticky",
            top: innerWidth > WIDTH_IPAD ? 160 : 120,
            zIndex: 11,
            width: "fit-content",
          }}>
          <Col className="kd-filter-products">
            <a
              id="filter"
              onClick={(e: any) => handleClickFilter(e)}
              className={`filter-main-item ${
                isShowFilters ? "filter-main-item-active" : ""
              }`}>
              <img
                src={isShowFilters ? ICON_SEARCH : ICON_SEARCH_2}
                alt=""
                style={{
                  width: innerWidth > WIDTH_IPAD ? 20 : isShowFilters ? 25 : 20,
                  transition: "0.3s",
                }}
              />
              <span className="title-filter">{t("filter")}</span>
              {isShowFilters ? (
                <div>
                  <CaretRightOutlined
                    style={{
                      color: "#0c3b5d",
                      fontSize: 16,
                    }}
                  />
                  <CaretRightOutlined
                    className="icon-arrow-2"
                    style={{ color: "#0c3b5d", fontSize: 16 }}
                  />
                </div>
              ) : null}
            </a>
            {Object.keys(filters).length &&
            !isShowFilters &&
            checkQuerySyntax(location.search) ? (
              <div className="quick-clear-filters">
                <a onClick={(e: any) => handleQuickClearFilters(e)}>
                  {innerWidth <= WIDTH_IPAD ? "X" : "Xoá lọc"}
                </a>
              </div>
            ) : null}
          </Col>
          {isShowFilters ? showFilterItems() : null}
        </Row>
      ) : null}
      {isShowOptions && productOptions.length ? (
        <FilterItemModal
          history={history}
          currentFilter={_.sortBy(currentFilter, ["order"])}
          closeModal={handleCloseModal}
          handleClickNextOrPrev={handleClickNextOrPrev}
          handleFilter={handleFilter}
          currentFilters={filters}
          isMobile={innerWidth <= WIDTH_IPAD}
          filterOptionList={filterOptionList}
          productOptions={productOptions}
          ref={refModal}
        />
      ) : null}
      <div style={{ flex: 1, width: "100%" }}>
        {dataProducts && dataProducts.length ? (
          _.sortBy(dataProducts, ["position"]).map(
            (category: any, i: number) => {
              if (
                !category.products.docs.length ||
                !category.products.docs.filter(
                  (item: any) =>
                    (item.data && item.data.length) ||
                    (item.specs && item.specs.length)
                ).length
              ) {
                return (
                  <div className="kd-empty-search">
                    <h3>{t("empty_search")}</h3>
                  </div>
                );
              }
              return (
                <div key={i}>
                  {_.sortBy(category.products.docs, ["position"]).map(
                    (product: any, index: number) => {
                      return (product.data && product.data.length) ||
                        (product.specs && product.specs.length) ? (
                        <div
                          id={`${slugify(product.name)}`}
                          key={index}
                          style={{
                            backgroundColor:
                              (i + index) % 2 === 0
                                ? "rgb(245, 245, 245)"
                                : "rgb(247, 248, 249)",
                          }}>
                          <div className="product-name-wrap">
                            <span className="large-title product-name-title ">
                              {product.name}
                            </span>
                          </div>

                          <FilterProduct
                            {...props}
                            slug={slug}
                            product={product}
                            data={product.data}
                            specs={product.specs}
                            parentIndex={index}
                          />
                        </div>
                      ) : null;
                    }
                  )}
                </div>
              );
            }
          )
        ) : (
          <div className="kd-empty-search">
            <h3>{!isLoading ? t("empty_search") : ""}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default withTranslation()(ProductsCategory);
